import React, { useState,useRef } from 'react';
import { addMCQToContest, updateContestMCQImage } from '../api/contestApi';
import { addMCQtoPS, publishAnnouncement, updateProblemSetMCQImage } from '../Helpers/firebaseHelpers'
import { useAuthUser } from './useAuthUser';

import { collection, getDocs, getDoc, doc } from "firebase/firestore";
import { db } from "../firebase-config";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase-config";

const AdminPanel = () =>
{
    const {userAuth , loading} = useAuthUser();
    const [contestId, setContestId] = useState('1');
    const [currentView, setCurrentView] = useState('select-choice');
    const [isAnnouncing, setIsAnnouncing] = useState(false);
    const [R_contestId,set_R_contestId] = useState(10000);
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [csvFile, setCsvFile] = useState(null);
    const [isSubmitting_PSet, setIsSubmitting_PSet] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [contestStd, setContestStd] = useState('0');
    const [processingRating, setProcessingRating] = useState(false);

    const [questionImageFile, setQuestionImageFile] = useState(null);
    const fileInputRef = useRef(null);

    const [Contest_questionImageFile, setContest_questionImageFile] = useState(null);
    const Contest_fileInputRef = useRef(null);

    const [Title, setTitle] = useState ({
            AnnouncementTitle: ''
        })
    
    const [AnnouncementText, setAnnouncementText] = useState ({
        AnnouncementData: ''
    })

    // The user being admin and logged in is taken care by the Profile.jsx file.

    const handlePublishAnnouncement = async () =>
    {
        if (!Title.AnnouncementTitle.trim() || !AnnouncementText.AnnouncementData.trim())
        {
            alert("Please fill in all the fields");
            return;
        }

        setIsAnnouncing(true);

        try
        {
            const result = await publishAnnouncement({
                title: Title.AnnouncementTitle,
                content: AnnouncementText.AnnouncementData
            });

            if (!result.success)
            {
                alert("An error occured while submitting your Announcement: " + result.error);
            }
        } catch (error)
        {
            console.error("Error while submitting the Announcement: ",error);
            alert("An error occured while submitting your Announcement");
        }

        setIsAnnouncing(false);
    }

    const [mcqData, setMcqData] = useState({
        WhichContest: 0,
        question: '',
        optionA: '',
        optionB: '',
        optionC: '',
        optionD: '',
        CorrectAnswer: [],
        difficulty: 0,
        points: 0,
        explanation: ''
    });

    const [mcqDataPSet, setMcqDataPSet] = useState(
    {
        Std: 0,
        Qname: '',
        Question: '',
        OptionA: '',
        OptionB: '',
        OptionC: '',
        OptionD: '',
        CorrectAnswer: [],
        Difficulty: 0,
        Explanation: ''
    });

    const authorizedAdmins =
    [
        'TanishqAC',
    ];

    const isAuthorized = () =>
    {
        const username = userAuth.displayName;
        return authorizedAdmins.includes(username);
    };

    const handleInputChange = (field, value) =>
    {
        setMcqData({
            ...mcqData,
            [field]: value
        });
    };

    const handleInputChange_PSet = (field, value) => 
    {
        setMcqDataPSet({
            ...mcqDataPSet,
            [field]: value
        })
    }

    const isFormValid = () =>
    {
        return mcqData.question.trim() !== '' &&
               mcqData.optionA.trim() !== '' &&
               mcqData.optionB.trim() !== '' &&
               mcqData.optionC.trim() !== '' &&
               mcqData.optionD.trim() !== '' &&
               mcqData.CorrectAnswer !== '';
    };

    const isFormValid_Rating_Changes = () => 
    {
        if (R_contestId >= 1 && R_contestId<=10000)
        {
            return true;
        } else 
        {
            return false;
        }
    }

    const isFormValid_PSet = () => 
    {
        return mcqDataPSet.Question.trim() !== '' &&
               mcqDataPSet.OptionA.trim() !== '' &&
               mcqDataPSet.OptionB.trim() !== '' &&
               mcqDataPSet.OptionC.trim() !== '' &&
               mcqDataPSet.OptionD.trim() !== '' &&
               mcqDataPSet.CorrectAnswer !== '';
    }

    const uploadQuestionImageIntoContest = async (file, ContestID, problemId) =>
    {
        if (!file) return null;

        const allowedTypes =
        [
            "image/jpeg",
            "image/png",
            "image/webp"
        ];

        if (!allowedTypes.includes(file.type))
        {
            alert("Unsupported error type", file.type);
            return null;
        }

        const MAX_SIZE = 8 * 1024 * 1024; // 8 MB
        if (file.size > MAX_SIZE)
        {
            alert("Image should be less than 8 MB");
            return null;
        }

        const imageRef = ref(
            storage,
            `Contest_Problem_Images/${ContestID}/${problemId}`
        );

        await uploadBytes(imageRef, file, { contentType: file.type });
        return await getDownloadURL(imageRef);
    };

    const handleSubmit = async () =>
    {
        if (!isFormValid() || !isAuthorized())
        {
            return;
        }
        
        setIsSubmitting(true);

        const username = userAuth.displayName;
        
        try
        {
            const targetContestId = String(mcqData.WhichContest || contestId);
            const result = await addMCQToContest(targetContestId, mcqData, username);

            const MCQ_Id = result.mcqId;

            let image_URL = null;

            if (result.success && Contest_questionImageFile)
            {
                image_URL = await uploadQuestionImageIntoContest(Contest_questionImageFile, targetContestId, MCQ_Id);
                await updateContestMCQImage(targetContestId, MCQ_Id, image_URL);
            }
            
            if ((result.success && !Contest_questionImageFile) || (result.success && Contest_questionImageFile && image_URL!=null))
            {
                alert('MCQ added successfully to contest ' + targetContestId + '!');
                // Reset form
                setMcqData({
                    WhichContest: 0,
                    question: '',
                    optionA: '',
                    optionB: '',
                    optionC: '',
                    optionD: '',
                    CorrectAnswer: [],
                    difficulty: 0,
                    points: 0,
                    explanation: ''
                });
            } else
            {
                alert('Failed to add MCQ: ' + (result.error ? result.error : 'Failed to upload the picture/image'));
            }
        } catch (error)
        {
            console.error('Error adding MCQ:', error);
            alert('An error occurred while adding the MCQ.');
        }
        setIsSubmitting(false);
        setContest_questionImageFile(null);
        Contest_fileInputRef.current.value = '';   // clear file input
    };

    const uploadQuestionImage = async (file, standard, problemId) =>
    {
        if (!file) return null;

        const allowedTypes =
        [
            "image/jpeg",
            "image/png",
            "image/webp"
        ];

        if (!allowedTypes.includes(file.type))
        {
            console.error("Unsupported image type:", file.type);
            return null;
        }

        const MAX_SIZE = 8 * 1024 * 1024; // 2MB
        if (file.size > MAX_SIZE)
        {
            alert("Image should be less than 2 MB");
            console.error("Image too large:", file.size);
            return null;
        }

        const imageRef = ref(
            storage,
            `problemImages/${standard}/${problemId}`
        );

        await uploadBytes(imageRef, file, { contentType: file.type });
        return await getDownloadURL(imageRef);
    };


    const handleSubmitPSet = async () => 
    {
        if (!isFormValid_PSet() || !isAuthorized())
        {
            return;
        }

        setIsSubmitting_PSet(true);

        try
        {
            const result = await addMCQtoPS(mcqDataPSet);
            let imageURL = null;

            if (result.success && questionImageFile)
            {
                const problemNum = result.problemId;
                imageURL = await uploadQuestionImage(questionImageFile,mcqDataPSet.Std.toString(),problemNum.toString());
                await updateProblemSetMCQImage(mcqDataPSet.Std.toString(), problemNum, imageURL);
            }
            
            if ((result.success && !questionImageFile) || (result.success && questionImageFile && imageURL!=null))
            {
                alert('MCQ added successfully to PS');
                // Reset form
                setMcqDataPSet({
                    Std: 0,
                    Question: '',
                    Qname:'',
                    OptionA: '',
                    OptionB: '',
                    OptionC: '',
                    OptionD: '',
                    CorrectAnswer: [],
                    Difficulty: 0,
                    Explanation: ''
                });
            } else
            {
                alert('Failed to add MCQ to Problem Set: ' + (result.error ? result.error : 'Cannot add image properly' ));
            }
        } catch (error)
        {
            console.error('Error adding MCQ to the Problem Set:', error);
            alert('An error occurred while adding the MCQ to the Problem Set.');
        }
        setIsSubmitting_PSet(false);
        setQuestionImageFile(null);
        fileInputRef.current.value = '';     // clear file input
    }

    if (!userAuth)
    {
        return (
            <div className="p-6 text-center">
                <h2 className="text-2xl mb-4">Please log in to access admin panel</h2>
            </div>
        );
    }

    if (!isAuthorized())
    {
        return (
            <div className="p-6 text-center">
                <h2 className="text-2xl mb-4 text-red-600">Access Denied</h2>
                <p className="text-gray-600">You are not authorized to access the Admin Panel.</p>
            </div>
        );
    }

    const exportToCSV = async () =>
    {
        const querySnapshot = await getDocs(
            collection(db, "contests", String(R_contestId), "contest_results")
        );

        if (querySnapshot.empty)
        {
            alert("No contest results found. CSV not generated.");
            return;
        }

        const rows = await Promise.all(
            querySnapshot.docs.map(async (docSnap) =>
            {
                const instance = docSnap.data();
                const { userName, totalScore } = instance;

                const userDoc = await getDoc(doc(db, "users", userName));
                const rating = userDoc.data().rating;

                return {
                    userName,
                    rating,
                    totalScore
                };
            })
        );

        const headers = ["userName", "rating", "totalScore"];
        const csv =
        [
            headers.join(","),
            ...rows.map(row =>
                headers.map(h => JSON.stringify(row[h] ?? "")).join(",")
            )
        ].join("\n");

        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "data.csv";
        a.click();

        URL.revokeObjectURL(url);
    };

    const uploadCSV = async () =>
    {
        setProcessingRating(true);

        const user = userAuth.currentUser;
        if (!user)
        {
            throw new Error("Not logged in");
        }
        const token = await user.getIdToken(); // Firebase-issued token

        const formData = new FormData();
        formData.append("participantsCsv", csvFile);
        formData.append("contestId", R_contestId);
        formData.append("contestStd", contestStd);

        await fetch( "/api/rating/calculate",
        {
            method: "POST",
            headers:
            {
                Authorization: `Bearer ${token}`
            },
            body: formData
        });

        setShowUploadModal(false);
        setProcessingRating(false);
    };

    return (
        <div>
        {
            currentView==='select-choice' ? (
                <div className="flex justify-center min-h-screen pt-24">
                    <div className="flex flex-col gap-2 items-center">
                        <button
                            className='text-4xl border border-black rounded-lg'
                            onClick={() => setCurrentView('add-MCQ')}
                            style=
                            {
                                {
                                    width: '400px',
                                    height: '80px',
                                    backgroundColor: '#27f8ffff'
                                }
                            }
                        >
                            Add MCQ to contests.
                        </button>

                        <button
                            className='text-3xl text-white border border-black rounded-lg'
                            onClick={() => setCurrentView('add-MCQ-PS')}
                            style=
                            {
                                {
                                    width: '400px',
                                    height: '80px',
                                    backgroundColor: '#0088ffff'
                                }
                            }
                        >
                            Add MCQ to Problem Set.
                        </button>

                        <button
                            className='text-3xl border border-black rounded-lg'
                            onClick={() => setCurrentView('Process-Rating-Changes')}
                            style=
                            {
                                {
                                    width: '300px',
                                    height: '80px',
                                    backgroundColor: '#00ff08ff'
                                }
                            }
                        >
                            Process Rating Changes
                        </button>

                        <button
                            className='text-3xl text-white border border-black rounded-lg'
                            onClick={() => setCurrentView('Announce')}
                            style=
                            {
                                {
                                    width: '400px',
                                    height: '80px',
                                    backgroundColor: '#ff0000ff'
                                }
                            }
                        >
                            Create An Announcement Post
                        </button>
                    </div>
                </div>
            ) : currentView==='add-MCQ' ? (
                <div className="max-w-4xl mx-auto p-6">
                    <div className="mb-6">
                        <h2 className="text-3xl font-bold mb-2">Admin Panel - Add MCQ</h2>
                        <p className="text-gray-600 text-xl">Add problems to contests</p>
                    </div>

                    <div className="bg-white rounded-lg shadow-md p-6 border border-gray-500">
                        <div className="mb-6">
                            <label className="block text-lg font-semibold mb-2">
                                Contest ID
                            </label>
                            <input
                                type="number"
                                value={mcqData.WhichContest}
                                onChange={ (e) => 
                                    {
                                        handleInputChange('WhichContest', parseInt(e.target.value) || 0);
                                        setContestId(e.target.value);
                                    }
                                }
                                min="1"
                                max="10000"
                                className="w-full p-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                            />
                        </div>

                        <div className="mb-6">
                            <label className="block text-lg font-semibold mb-2 text-red-600">
                                Question Statement *
                            </label>
                            <textarea
                                value={mcqData.question}
                                onChange={(e) => handleInputChange('question', e.target.value)}
                                placeholder="Enter the question here..."
                                className="w-full p-4 border border-gray-300 rounded-lg h-32 resize-none focus:border-blue-500 focus:outline-none"
                            />
                        </div>

                        <div className="mt-4 mb-4">
                            <label className="block text-red-600 text-lg font-medium mb-1">
                                Question Image <span className='text-blue-600'>(optional)</span>
                            </label>

                            <input
                                ref={Contest_fileInputRef}
                                type="file"
                                accept="image/*"
                                onChange={(e) => setContest_questionImageFile(e.target.files[0])}
                            />

                            {Contest_questionImageFile && (
                                <p className="text-md text-green-700 mt-1">
                                Selected: {Contest_questionImageFile.name}
                                </p>
                            )}
                        </div>

                        <div className="mb-6">
                            <label className="block text-lg font-semibold mb-4 text-red-600">
                                Options *
                            </label>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {['A', 'B', 'C', 'D'].map((option) => (
                                    <div key={option}>
                                        <label className="block text-sm font-medium mb-2">
                                            Option {option}
                                        </label>
                                        <input
                                            type="text"
                                            value={mcqData[`option${option}`]}
                                            onChange={(e) => handleInputChange(`option${option}`, e.target.value)}
                                            placeholder={`Enter option ${option}`}
                                            className="w-full p-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="mb-6">
                            <label className="block text-lg font-semibold mb-2 text-red-600">
                                Correct Answer *
                            </label>
                            <select
                                value={mcqData.CorrectAnswer}
                                onChange={(e) => handleInputChange('CorrectAnswer', e.target.value)}
                                className="w-full p-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                            >
                                <option value="">Select correct answer</option>
                                <option value="A">A</option>
                                <option value="B">B</option>
                                <option value="C">C</option>
                                <option value="D">D</option>
                            </select>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                            <div>
                                <label className="block text-lg font-semibold mb-2">
                                    Difficulty
                                </label>
                                <input
                                    type="number"
                                    value={mcqData.difficulty}
                                    onChange={(e) => handleInputChange('difficulty', parseInt(e.target.value) || 1)}
                                    min="1"
                                    max="100"
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                                />
                            </div>
                            <div>
                                <label className="block text-lg font-semibold mb-2">
                                    Points
                                </label>
                                <input
                                    type="number"
                                    value={mcqData.points}
                                    onChange={(e) => handleInputChange('points', parseInt(e.target.value) || 1)}
                                    min="1"
                                    max="100"
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                                />
                            </div>
                        </div>

                        <div className="mb-6">
                            <label className="block text-lg font-semibold mb-2">
                                Explanation (Optional)
                            </label>
                            <textarea
                                value={mcqData.explanation}
                                onChange={(e) => handleInputChange('explanation', e.target.value)}
                                placeholder="Explain the solution..."
                                className="w-full p-4 border border-gray-300 rounded-lg h-24 resize-none focus:border-blue-500 focus:outline-none"
                            />
                        </div>

                        <div className="flex justify-end">
                            <button
                                onClick={handleSubmit}
                                disabled={!isFormValid() || isSubmitting}
                                className={`px-8 py-3 rounded-lg text-lg font-medium transition-all ${
                                    isFormValid() && !isSubmitting
                                        ? 'bg-blue-600 hover:bg-blue-700 text-white cursor-pointer'
                                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                }`}
                            >
                                {isSubmitting ? 'Adding MCQ...' : 'Add MCQ to Contest'}
                            </button>
                        </div>
                    </div>
                </div>
            ) : currentView==='add-MCQ-PS' ? (
                <div className="max-w-4xl mx-auto p-6">
                    <div className="mb-6">
                        <h2 className="text-3xl font-bold mb-2">Admin Panel - Add MCQ to Problem Set</h2>
                        <p className="text-gray-600 text-xl">Add problems to problem set</p>
                    </div>

                    <div className="bg-white rounded-lg shadow-md p-6 border border-gray-500">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                            <div>
                                <label className="block text-lg font-semibold mb-2">
                                    Standard
                                </label>
                                <input
                                    type="number"
                                    value={mcqDataPSet.Std}
                                    onChange={(e) => handleInputChange_PSet('Std', parseInt(e.target.value) || 0)}
                                    min="1"
                                    max="12"
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                                />
                            </div>
                        </div>

                        <div className="mb-6">
                            <label className="block text-lg font-semibold mb-2 text-red-600">
                                Question Name *
                            </label>
                            <textarea
                                value={mcqDataPSet.Qname}
                                onChange={(e) => handleInputChange_PSet('Qname', e.target.value)}
                                placeholder="Enter the name of the question here..."
                                className="w-full p-4 border border-gray-300 rounded-lg h-13 resize-none focus:border-blue-500 focus:outline-none"
                            />
                        </div>

                        <div className="mb-6">
                            <label className="block text-lg font-semibold mb-2 text-red-600">
                                Question Statement *
                            </label>
                            <textarea
                                value={mcqDataPSet.Question}
                                onChange={(e) => handleInputChange_PSet('Question', e.target.value)}
                                placeholder="Enter the question here..."
                                className="w-full p-4 border border-gray-300 rounded-lg h-32 resize-none focus:border-blue-500 focus:outline-none"
                            />
                        </div>

                        <div className="mt-4 mb-4">
                            <label className="block text-red-600 text-lg font-medium mb-1">
                                Question Image <span className='text-blue-600'>(optional)</span>
                            </label>

                            <input
                                ref={fileInputRef}
                                type="file"
                                accept="image/*"
                                onChange={(e) => setQuestionImageFile(e.target.files[0])}
                            />

                            {questionImageFile && (
                                <p className="text-md text-green-700 mt-1">
                                Selected: {questionImageFile.name}
                                </p>
                            )}
                        </div>

                        <div className="mb-6">
                            <label className="block text-lg font-semibold mb-4 text-red-600">
                                Options *
                            </label>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {['A', 'B', 'C', 'D'].map((option) => (
                                    <div key={option}>
                                        <label className="block text-sm font-medium mb-2">
                                            Option {option}
                                        </label>
                                        <input
                                            type="text"
                                            value={mcqDataPSet[`Option${option}`]}
                                            onChange={(e) => handleInputChange_PSet(`Option${option}`, e.target.value)}
                                            placeholder={`Enter option ${option}`}
                                            className="w-full p-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="mb-6">
                            <label className="block text-lg font-semibold mb-2 text-red-600">
                                Correct Answer *
                            </label>

                            <div className="space-y-2">
                            {["A", "B", "C", "D"].map((option) => (
                                <label key={option} className="flex items-center space-x-2">
                                    <input
                                        type="checkbox"
                                        value={option}
                                        checked={mcqDataPSet.CorrectAnswer.includes(option)}
                                        onChange={(e) => {
                                        const checked = e.target.checked;

                                        setMcqDataPSet((prev) => ({
                                            ...prev,
                                            CorrectAnswer: checked
                                            ? [...prev.CorrectAnswer, option]               // add
                                            : prev.CorrectAnswer.filter((x) => x !== option) // remove
                                        }));
                                        }}
                                        className="w-4 h-4"
                                    />
                                    <span>{option}</span>
                                </label>
                            ))}
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                            <div>
                                <label className="block text-lg font-semibold mb-2">
                                    Difficulty
                                </label>
                                <input
                                    type="number"
                                    value={mcqDataPSet.Difficulty}
                                    onChange={(e) => handleInputChange_PSet('Difficulty', parseInt(e.target.value) || 1)}
                                    min="0"
                                    max="101"
                                    className="w-full p-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                                />
                            </div>
                        </div>

                        <div className="mb-6">
                            <label className="block text-lg font-semibold mb-2">
                                Explanation (Optional)
                            </label>
                            <textarea
                                value={mcqDataPSet.Explanation}
                                onChange={(e) => handleInputChange_PSet('Explanation', e.target.value)}
                                placeholder="Explain the solution..."
                                className="w-full p-4 border border-gray-300 rounded-lg h-24 resize-none focus:border-blue-500 focus:outline-none"
                            />
                        </div>

                        <div className="flex justify-end">
                            <button
                                onClick={handleSubmitPSet}
                                disabled={!isFormValid_PSet() || isSubmitting_PSet}
                                className={`px-8 py-3 rounded-lg text-lg font-medium transition-all ${
                                    isFormValid_PSet() && !isSubmitting_PSet
                                        ? 'bg-blue-600 hover:bg-blue-700 text-white cursor-pointer'
                                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                }`}
                            >
                                {isSubmitting_PSet ? 'Adding MCQ...' : 'Add MCQ to Problem Set'}
                            </button>
                        </div>
                    </div>
                </div>
            ) : currentView==='Announce' ? (
                <div className="p-4 md:p-8 max-w-4xl mx-auto">
                    <h2 className="text-3xl font-bold mb-6 text-gray-800 border-b pb-2">
                        📌 Create A New Announcement Post
                    </h2>
                    <div className="space-y-6">

                        {/* Announcement Title Input */}
                        <div>
                            <label 
                                htmlFor="announcement-title" 
                                className="block text-sm font-medium text-gray-700 mb-2"
                            >
                                Announcement Title
                            </label>
                            <input
                                id="announcement-title"
                                type="text"
                                value={Title.AnnouncementTitle}
                                onChange={(e) => setTitle({...Title, AnnouncementTitle: e.target.value})}
                                placeholder="Enter the title of your Announcement"
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                                disabled={isAnnouncing}
                            />
                        </div>

                        {/* Announcement Content Textarea */}
                        <div>
                            <label 
                                htmlFor="blog-content" 
                                className="block text-sm font-medium text-gray-700 mb-2"
                            >
                                Announcement Content
                            </label>
                            <textarea
                                id="blog-content"
                                rows="15"
                                value={AnnouncementText.AnnouncementData}
                                onChange={(e) => setAnnouncementText({...AnnouncementText, AnnouncementData: e.target.value})}
                                placeholder="Start writing your Announcement here..."
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 resize-y"
                                disabled={isAnnouncing}
                            />
                        </div>

                        {/* Publish Button */}
                        <button
                            onClick={handlePublishAnnouncement}
                            disabled={isAnnouncing}
                            className={`
                                w-full px-6 py-3 text-lg font-semibold rounded-lg transition duration-150 ease-in-out
                                ${isAnnouncing 
                                    ? 'bg-gray-400 cursor-not-allowed' 
                                    : 'bg-indigo-600 hover:bg-indigo-700 text-white shadow-md'
                                }
                            `}
                        >
                            {isAnnouncing ? 'Publishing...' : 'Publish Announcement'}
                        </button>
                        
                        {/* Displaying User Info for context */}
                        <div className="pt-4 text-lg text-black border-t mt-6">
                            Announcing as: {userAuth.displayName}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="max-w-4xl mx-auto p-6">
                    <div className="mb-6">
                        <h2 className="text-3xl font-bold mb-2">Admin Panel - Process Rating Changes</h2>
                        <p className="text-gray-600 text-2xl">Apply deltas and update ratings</p>
                    </div>

                    <div className="bg-white rounded-lg shadow-md p-6 border border-gray-500">
                        <div className="mb-6">
                            <label className="block text-xl font-semibold mb-2">
                                Contest ID for which changes are to be applied.
                            </label>
                            <input
                                type="number"
                                value={R_contestId}
                                onChange={ (e) => 
                                    {
                                        set_R_contestId(e.target.value);
                                    }
                                }
                                min="1"
                                max="10000"
                                className="w-full p-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                            />
                        </div>

                        <div className="mb-6">
                            <label className="block text-xl font-semibold mb-2">
                                Standard of the corresponding contest.
                            </label>
                            <input
                                type="number"
                                value={contestStd}
                                onChange={ (e) => 
                                    {
                                        setContestStd(e.target.value);
                                    }
                                }
                                min="1"
                                max="12"
                                className="w-full p-3 border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                            />
                        </div>

                        <div className="flex justify-end">
                            <button
                                onClick=
                                {
                                    async () => 
                                    {
                                        await exportToCSV();
                                        setShowUploadModal(true);
                                    }
                                }
                                disabled={!isFormValid_Rating_Changes() || processingRating}
                                className={`px-8 py-3 rounded-lg text-lg font-medium transition-all ${
                                    isFormValid_Rating_Changes() && !processingRating
                                        ? 'bg-blue-600 hover:bg-blue-700 text-white cursor-pointer'
                                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                }`}
                            >
                                {processingRating ? 'Rating engine is runnning...' : 'Process the rating changes'}
                            </button>
                        </div>
                        {
                            showUploadModal &&
                            (
                                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                                    <div className="bg-white p-6 rounded-lg w-96">
                                        <h2 className="text-xl font-semibold mb-4">
                                            Upload downloaded CSV
                                        </h2>

                                        <input
                                            type="file"
                                            accept=".csv"
                                            onChange={(e) => setCsvFile(e.target.files[0])}
                                        />

                                        <div className="flex justify-end gap-4 mt-6">
                                            <button
                                                onClick={() => setShowUploadModal(false)}
                                                className="px-4 py-2 bg-gray-300 rounded"
                                            >
                                                Cancel
                                            </button>

                                            <button
                                                disabled={!csvFile}
                                                onClick={uploadCSV}
                                                className="px-4 py-2 bg-blue-600 text-white rounded"
                                            >
                                                Upload & Run
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            )
        }
        </div>
    );
};

export default AdminPanel;
